import React from "react";

import FacetController from "../../../../../../../src-js/Fratello/ProductBrowser/Controllers/FacetController";

export default function FacetsWidget(props) {

    return (
        <section className="filter-browser">
            <header className="filter-header">
                <div className="row">
                    <div className="col-md-12 col-xs-6">
                        <h1 className="filter-header-title">Filters</h1>
                    </div>
                    <div className="col-xs-6 hidden-md-up" onClick={(event)=> {
                        let self = $(event.currentTarget),
                            parent = self.closest('.filter-browser');
                        if(!parent.hasClass('active')) {
                            parent.addClass('active');
                        } else {
                            parent.removeClass('active');
                        }
                    }}>
                        <a href="#" className="btn btn-link no-padding pull-right js-toggle-hidden-filters"><i className="icon icon-arrow-down color-purple"></i></a>
                    </div>
                </div>
            </header>
            <div className="filter-content clearfix">
                <FacetController {...props} />
            </div>
        </section>);
}



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductBrowser/Widgets/FacetsWidget.jsx